
namespace RioERP.Orders {
    export class FranchiseePaymentsColumns {
        static columnsKey = 'Orders.FranchiseePayments';
    }
}